{
    "AuthoriseButton_Title": "Authorize",
    "PreAuthoriseButton_Title": "Pre-Authorize",
    "Authentication_PreAuthorisation_Successful": "Pre-Authorized",
    "Authentication_Successful": "Authorization Granted",
    "Authentication_Failed": "The Authorization process has failed.",
    "Authentication_Authenticated": "This Telephony Server has already been Authorized.",
    "Authentication_CrmAuthenticated": "This CRM has already been authorised.",
    "Authentication_Status_Title": "Auth Status",
    "Authentication_Status_Warning": "There is a warning for this authorization, you can try to re-authorize to fix this.",
    "Authentication_Status_Warning_Range_30100_30199": "Authorization Successful, but a problem has been detected communicating with MS Teams. Please contact Akixi customer support.",
    "Authentication_Status_Warning_Range_30200_30299": "Authorization Successful, but a problem has been detected synchronising with MS Teams. Please contact Akixi customer support.",
    "NAME": "OAuthButton"
}
